import { useDispatch, useSelector } from "react-redux";
import { FORMA_PAGO_TYPES } from "../constants/forma-pago..types";
import { ActionFP, FormFormaPago, Pago } from "../interfaces/forma-pago.interface";
import { State } from "../reducers";
import * as http from '../api/http'
import { ENDPOINTS } from "../api/config";
import { CATALOGOS_TYPES } from "../constants/catalogos.types";
import { generalOpenModalInfo } from "./general.actions";
import { useEffect } from "react";
import { validarRegexNumericoFloat2Decimales, validarRegexNumericoInt } from "../utils/strings.utils";
import { FacturacionAction } from "../interfaces/facturacion.interface";

export default function useFormaPago (totalAPagar: any){
    const {formFormaPago, errorsFormaPago, pagos} = useSelector((state: State) => state.formaPago)
    const {condicionesPago} = useSelector((state: State) => state.catalogos)
    const dispatch = useDispatch()

    const onChangeForm = (field: string, value: string) => {
        if(!validateChange(field, value)) return

        dispatch(handleChangeForm({...formFormaPago, [field] : value}))
        validateForm(field, value)
    }

    const validateChange = (field: string, value: string) => {
        switch(field){
            case 'monto':
                return validarRegexNumericoFloat2Decimales(value)
            case 'periodo':
                return validarRegexNumericoInt(value)
            default:
                return true
        }
    }

    const validateForm = (field: string, value: string) => {
        let condicionCreditoCode = condicionesPago.find((condicion) => condicion.valor === 'A crédito')?.codigo
        let message = ''
        switch(field){
            case 'monto':
                const montoRedondeado = parseFloat(parseFloat(value || '0').toFixed(2));
                if(montoRedondeado <= 0) {
                    message = 'El monto es requerido';
                    break;
                }
                if(montoRedondeado > parseFloat(parseFloat(totalAPagar || '0').toFixed(2))) {
                    message = 'El monto no puede ser mayor al total a pagar';
                    break;
                }
                if((calculosPagos().montoTotal + montoRedondeado) > parseFloat(parseFloat(totalAPagar || '0').toFixed(2))) {
                    message = 'El monto excede el total a pagar';
                    break;
                }
                break;
            case 'plazo':
                if(formFormaPago.condicion === condicionCreditoCode){
                    if(value.trim() === ''){message = 'Plazo es requerido'; break;}
                }
                break;
            case 'periodo':
                if(formFormaPago.condicion === condicionCreditoCode){
                    if(value.trim() === ''){message = 'Período es requerido'; break;}
                }
                break;
            default:
                break;
        }

        dispatch(handleErrorsForm({...errorsFormaPago, [field] : message}))

        return message
    }

    const setTotalAPagar = (total: string) => {
        dispatch(handleSetTotalAPagar(total))
    }

    const button_agregarPago = () => {
        let tempArray = pagos
        let errors: {[key: string] : string } = {}

        for (const field in formFormaPago){
            errors[field] = validateForm(field, formFormaPago[field])
        }

        dispatch(handleErrorsForm({...errorsFormaPago, ...errors}))

        if(Object.values(errors).some((err) => err !== '')) return;
        
        if((parseFloat(calculosPagos().montoTotal.toFixed(2)) + parseFloat(parseFloat(formFormaPago.monto).toFixed(2))) <= parseFloat(parseFloat(totalAPagar).toFixed(2))) {
            tempArray.push({
                id: Math.floor(Math.random() * 900000) + 100000,
                formaPago: formFormaPago.formaPago,
                monto: parseFloat(formFormaPago.monto).toFixed(2), // Redondeamos y formateamos a 2 decimales aquí también
                numeroDocumento: formFormaPago.numeroDocumento,
                plazo: formFormaPago.plazo,
                periodo: formFormaPago.periodo
            })
            dispatch(handleSetPagos(tempArray))
        } else {
            dispatch(generalOpenModalInfo('El monto que ingresaste excede el total a pagar.'))
        }
        dispatch(handleChangeForm({
            ...formFormaPago,
            formaPago: '01',
            monto: '',
            plazo: '',
            numeroDocumento: '',
            periodo: '',
        }))

    }

    const setTablePagos = (pagos: any) => {
        dispatch(handleSetTablePagos(pagos))
    }

    const actionButton_quitarpago = (id: any) => {
        let tempArray = pagos.filter((pago) => pago.id !== id)
        dispatch(handleSetPagos(tempArray))
    }

    const calculosPagos = () => {
        let sumaTotal = 0

        pagos.forEach((pago) => {
            sumaTotal += parseFloat(parseFloat(pago.monto).toFixed(2))
        })

        return {
            montoTotal: sumaTotal
        }
    }

    const vaciarPagos = () => {
        dispatch(handleSetPagos([]))
    }

    useEffect(() => {
        if(calculosPagos().montoTotal.toFixed(2) === parseFloat(totalAPagar).toFixed(2)){
            dispatch(handleSetPagoCompletado(true))
        } else {
            dispatch(handleSetPagoCompletado(false))
        }
    }, [pagos.length, totalAPagar])

    return {
        onChangeForm,
        setTotalAPagar,
        setTablePagos,
        vaciarPagos,
        calculosPagos,

        button_agregarPago,

        actionButton_quitarpago
    }
}

export const handleRestartStateFormaPago = ():ActionFP | FacturacionAction => ({type: FORMA_PAGO_TYPES.FP_RESTART_STATE, payload: null}) 
const handleChangeForm = (form: FormFormaPago):ActionFP => ({type: FORMA_PAGO_TYPES.FP_HANDLE_CHANGE_FORM, payload: form})
const handleErrorsForm = (errors: FormFormaPago):ActionFP => ({type: FORMA_PAGO_TYPES.FP_HANDLE_ERRORS_FORM, payload: errors})
const handleSetTotalAPagar = (totalAPagar: any):ActionFP => ({type: FORMA_PAGO_TYPES.FP_HANDLE_ERRORS_FORM, payload: totalAPagar})
const handleSetPagos = (pagos: Array<Pago>):ActionFP => ({type: FORMA_PAGO_TYPES.FP_HANDLE_SET_PAGOS, payload: pagos})
const handleSetTablePagos = (pagos: any):ActionFP => ({type: FORMA_PAGO_TYPES.FP_HANDLE_SET_TABLE_PAGOS, payload: pagos})
const handleSetPagoCompletado = (completo: boolean):ActionFP => ({type: FORMA_PAGO_TYPES.FP_HANDLE_SET_PAGO_COMPLETADO, payload: completo})